import React from "react";
import { Tag, Space, Button, Popconfirm } from "antd";
import {
  SettingOutlined,
  LockOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

const getRoleColor = (role) => {
  const map = {
    admin: "#49627a",
    role1: "#2b751d",
    role2: "#e29b45",
    role3: "#bd565d",
  };
  return map[role] || "default";
};

export default function SkeyenoteUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onEditEmail,
  onEditRoles,
  onResetPassword,
  onDeleteUser,
  isRoleUser,
}) {
  const columns = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: "20%",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
    },
    {
      title: "Email",
      key: "email",
      width: "30%",
      render: (_, record) => (
        <Space>
          <span>{record.email || "N/A"}</span>
          {!isRoleUser && (
            <Button
              type="text"
              size="small"
              icon={<SettingOutlined />}
              onClick={() => onEditEmail(record)}
              style={{ color: "#e29b45" }}
              title="Edit Email"
            />
          )}
        </Space>
      ),
    },
    {
      title: "Roles",
      key: "roles",
      width: isRoleUser ? "50%" : "30%",
      render: (_, record) => (
        <Space>
          {Array.isArray(record.roles)
            ? record.roles.map((role, idx) => (
                <Tag color={getRoleColor(role)} key={idx}>
                  {role}
                </Tag>
              ))
            : "N/A"}
          {!isRoleUser && (
            <Button
              type="text"
              size="small"
              icon={<SettingOutlined />}
              onClick={() => onEditRoles(record)}
              style={{ color: "#49627a" }}
              title="Manage Roles"
            />
          )}
        </Space>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: "20%",
      render: (_, record) =>
        !isRoleUser && (
          <Space size="small">
            <Button
              type="text"
              icon={<LockOutlined />}
              onClick={() => onResetPassword(record)}
              style={{ color: "#2b751d" }}
              title="Reset Password"
            />
            <Popconfirm
              title="Delete User"
              description={
                <span>
                  Are you sure you want to delete <b>{record.username}</b>?
                </span>
              }
              onConfirm={() => onDeleteUser(record.username)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                title="Delete User"
              />
            </Popconfirm>
          </Space>
        ),
    },
  ];

  return (
    <DataTable
      rowKey="username"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      sticky
      pageSizeOptions={[10, 25, 50, 100]}
    />
  );
}
